export default "__VITE_ASSET__6v__CTaD__"